import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { UtensilsCrossed, Sparkles, Home as HomeIcon, Wine, ArrowRight, Loader2 } from 'lucide-react';
import api from '../services/api';
import { sortCategories } from '../services/sort';

const ICONS = {
  'alimentos': UtensilsCrossed,
  'cuidado-personal': Sparkles,
  'hogar': HomeIcon,
  'licores-bebidas': Wine,
};

const Categorias = () => {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let on = true;
    Promise.all([api.get('/categories'), api.get('/brands')])
      .then(([c, b]) => {
        if (!on) return;
        setCategories(sortCategories(c.data));
        setBrands(b.data);
      })
      .finally(() => on && setLoading(false));
    return () => { on = false; };
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
      <div>
        <h1 className="text-4xl font-bold tracking-tight text-slate-900">Categorías de Productos</h1>
        <p className="mt-2 text-slate-600">Explora las marcas y productos organizados por categoría.</p>
      </div>

      {loading ? (
        <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-emerald-700" /></div>
      ) : (
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-2">
          {categories.map(cat => {
            const count = brands.filter(b => b.category === cat.name).length;
            const Icon = ICONS[cat.slug] || UtensilsCrossed;
            return (
              <Link
                key={cat.id}
                to={`/productos?category=${cat.slug}`}
                className="group relative flex items-center justify-between overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-emerald-300 hover:shadow-md"
              >
                <div className="flex items-center gap-5">
                  <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-emerald-50 text-emerald-700 transition-colors group-hover:bg-emerald-100">
                    <Icon className="h-7 w-7" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-slate-900 group-hover:text-emerald-800">{cat.name}</h3>
                    <p className="mt-1 text-sm text-slate-500">{count} {count === 1 ? 'marca' : 'marcas'}</p>
                  </div>
                </div>
                <ArrowRight className="h-5 w-5 text-slate-400 transition-transform duration-200 group-hover:translate-x-1 group-hover:text-emerald-700" />
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Categorias;
